import React from 'react';
import { render } from 'react-dom'
import MusicPlayer from 'react-responsive-music-player';

import "typeface-concert-one";
import './index.scss';



const original_playlist = [
      {
        url: 'm/Wu Forever! (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

      {
        url: 'm/\'Til I Make It.wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
          'feat. Monica Delgado',
          'Prod. By KeithCharlesSpacebar',
        ]
      },

      {
        url: 'm/All Falls Down (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

      {
        url: 'm/Boombap Gold (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

      {
        url: 'm/Boombap Is Back (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

      {
        url: 'm/Dream of Me (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

      {
        url: 'm/Escape.wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
          'Prod. By Sponatola',
        ]
      },

      {
        url: 'm/Evoke (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

      {
        url: 'm/Fast As I Can.wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
          'feat. Jay Atoms',
          'Prod. By Tuelv',
        ]
      },

      {
        url: 'm/I Just Go....wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
          'Prod. By Khep',
        ]
      },

      {
        url: 'm/I\'m Gonna (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

      {
        url: 'm/Like Kings.wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
          'Prod. By Beyobe',
        ]
      },

      {
        url: 'm/Like That.wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
          'Prod. By Tuelv',
        ]
      },

      {
        url: 'm/Palm Trees (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

      {
        url: 'm/Petey (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

      {
        url: 'm/Petey Too (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

      {
        url: 'm/Raindrops Race (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

      {
        url: 'm/Sky Groovin\' (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

      {
        url: 'm/Small World.wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
          'Prod. By Tuelv',
        ]
      },

      {
        url: 'm/Smooth Forces (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

      {
        url: 'm/Strange Things (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

      {
        url: 'm/Summer Money (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

      {
        url: 'm/Tea Not Gossip (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

      {
        url: 'm/Tell Me (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

      {
        url: 'm/The Things (Instrumental).wav',
        cover: 'i/mike-mass.jpg',
        artist: [
          'Mike Mass',
        ]
      },

//       {
//         url: 'm/Boombap Gold (Instrumental).wav',
//         cover: 'i/mike-mass.jpg',
//         artist: [
//           'Mike Mass',
//         ]
//       },
//       {
//         url: 'm/Im Gonna.wav',
//         cover: 'i/mike-mass.jpg',
//         artist: [
//           'Mike Mass',
//         ]
//       },
//       {
//         url: 'm/katstuff.wav',
//         cover: 'i/mike-mass.jpg',
//         title: 'kat stuff',
//         artist: [
//           'Mike Mass',
//         ]
//       },
//       {
//         url: 'm/lofi heat.wav',
//         cover: 'i/mike-mass.jpg',
//         title: 'lofi heat',
//         artist: [
//           'Mike Mass',
//         ]
//       },
//       {
//         url: 'm/mass lofi - 2.wav',
//         cover: 'i/mike-mass.jpg',
//         title: 'mass lofi',
//         artist: [
//           'Mike Mass',
//         ]
//       },
//       {
//         url: 'm/petey 2 - 1.wav',
//         cover: 'i/mike-mass.jpg',
//         title: 'petey too',
//         artist: [
//           'Mike Mass',
//         ]
//       },
//       {
//         url: 'm/petey new.wav',
//         cover: 'i/mike-mass.jpg',
//         title: 'petey new',
//         artist: [
//           'Mike Mass',
//         ]
//       },
//       {
//         url: 'm/sky groovin - 1.wav',
//         cover: 'i/mike-mass.jpg',
//         title: 'sky groovin',
//         artist: [
//           'Mike Mass',
//         ]
//       },
//       {
//         url: 'm/strange things.wav',
//         cover: 'i/mike-mass.jpg',
//         title: 'strange things',
//         artist: [
//           'Mike Mass',
//         ]
//       },
//       {
//         url: 'm/tea not gossip.wav',
//         cover: 'i/mike-mass.jpg',
//         title: 'tea not gossip',
//         artist: [
//           'Mike Mass',
//         ]
//       },
      {
        url: 'm/Elephant_Funeral_-_07_-_Take_Me_Back_Ft_Isaiah_Thomas.mp3',
        cover: 'https://picsum.photos/600?grayscale',
        title: 'Take Me Back Ft Isaiah Thomas',
        artist: [
          'Elephant Funeral',
        ]
      },
      {
        url: 'm/J1_-_03_-_Floridian_Fighting_Bear.mp3',
        cover: 'https://picsum.photos/601?grayscale',
        title: 'Floridian Fighting Bear',
        artist: [
          'J1'
        ]
      },
      {
        url: 'm/Shaolin_Dub_-_06_-_Pied_Piper.mp3',
        cover: 'https://picsum.photos/602?grayscale',
        title: 'Pied Piper',
        artist: [
          'Shaolin Dub'
        ]
      },
      {
        url: 'm/Vincent_Augustus_-_05_-_John_Coffee_Freestyle.mp3',
        cover: 'https://picsum.photos/603?grayscale',
        title: 'John Coffee Freestyle',
        artist: [
          'Vincent Augustus'
        ]
      },
      {
        url: 'm/Yung_Kartz_-_02_-_Young_and_Reckless.mp3',
        cover: 'https://picsum.photos/604?grayscale',
        title: 'Young and Reckless',
        artist: [
          'Yung Kartz'
        ]
      }
    ];

function shuffle(a) { 
    a.sort(() => Math.random() - 0.5);
}
shuffle(original_playlist);

for (var value of original_playlist) {
    if (value.title === undefined || value.title == '') {
        value.title = value.url.replace(/m\/(.*)\.[a-z]{3}/, '$1');
    }
}

const options = {
    
    mode: 'horizontal', // set the layout of player: vertical or horizontal

    width: '100%', // number, string

    autoplay: false, // bool
    
    playMode: 'random', // loop|random
    
    playlist: original_playlist,

    onAudioPlay(audioInfo) {
        console.log("audio play", audioInfo);
    },

}

// class App extends Component {
//   render() {
//     return (
//       <div>
//         <MusicPlayer {...options} />
//       </div>
//     );
//   }
// }
let MusicPlayerRendered = render(<MusicPlayer {...options} />, document.querySelector('#root'))
setTimeout(function() {
    MusicPlayerRendered.setState({ playMode: 'random' });
}.bind(this), 300)
// this just doesn't work in production
// setTimeout(function() {
//     MusicPlayerRendered.handleToggle();
// }.bind(this), 1000)

